import React, { useState } from "react";
import { styled } from "@mui/material/styles";

import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";

import ActionsIcon from "../../../assets/Icons/Actions Icon 2.png";
import AcIcon from "../../../assets/Icons/AC Icon.png";
import TeroIcom from "../../../assets/Icons/Linear Termometar White.png";
import ConferenceIcon from "../../../assets/Icons/ConfRoom Action.png";
import OcoIcon from "../../../assets/Icons/Occupancy Action.png";

import DisplayAction from "../../../assets/Icons/Display Action White.png";
import DisplayactionYellow from "../../../assets/Icons/Display Action Yellow.png";

import Projector from "../../../assets/Icons/Projector-Action-White.png";
import ProjectorYellow from "../../../assets/Icons/Projector-Action-Yellow.png";
import Graph from "../../../assets/Icons/Graph.png";

import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import LineChart from './chart'

import TemperatureSlider from './tempratureSlider'
import "./index.css";
import {
  cardHeading,
  cardSubHeading,
  cardHeaderStyle,
  cardHeaderStyle2,
  tempStyle,
  displayConf,
} from "./style";

const Item = styled(Paper)(({ theme }) => ({
  background: "#212121 !important",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  height: 315,
  textAlign: "center",
  color: theme.palette.text.secondary,
  borderRadius: "15px",
  [theme.breakpoints.up("lg")]: {
    // width: 550,
    paddingLeft: "20px",
  },
  [theme.breakpoints.down("sm")]: {
    height: "auto",
    width: "330px"
  },
}));

const ButtonItem = styled(Button)(({ theme }) => ({
  backgroundColor: "#3E3E3E",
  borderRadius: "10px",
  width: 167,
  height: 61,
  color: "#FFFFFF",
}));

const DashboardComponent = () => {
  const [videoDisplay, setVideoDisplay] = useState<boolean>(false);
  const [projectorDisplay, setProjectorDisplay] = useState<boolean>(false);
  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.name === "display") {
      setVideoDisplay(event.target.checked);
      return;
    } else if (event.target.name === "projector") {
      setProjectorDisplay(event.target.checked);
      return;
    }
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={4} sx={{ mt: 4 }}>
        <Grid xs={12} md={6}>
          <Item>
            <Grid container>
              <Grid xs={12} sm={12} md={12} sx={cardHeaderStyle}>
                <Avatar
                  sx={{ width: 49, height: 49 }}
                  alt="Cindy Baker"
                  src={ActionsIcon}
                />
                <div className="typography-div">
                  <Typography sx={cardHeading}>Quick actions</Typography>
                  <Typography variant="caption" sx={cardSubHeading}>Preset buttons</Typography>
                </div>
              </Grid>
              <Grid xs={12} sm={6} md={6}>
                <ButtonItem>Wake Up </ButtonItem>
              </Grid>
              <Grid xs={12} sm={6} md={6}>
                <ButtonItem>Sleep </ButtonItem>
              </Grid>
              <Grid xs={12} sm={6} md={6}>
                <ButtonItem>Night Mode </ButtonItem>
              </Grid>
              <Grid xs={12} sm={6} md={6}>
                <ButtonItem>Day Mode </ButtonItem>
              </Grid>
            </Grid>
          </Item>
        </Grid>

        <Grid xs={12} md={6}>
          <Item>
            <Grid container>
              <Grid xs={12} md={12} sx={cardHeaderStyle2}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Avatar
                    sx={{ width: 49, height: 49 }}
                    alt="Ac Icon"
                    src={AcIcon}
                  />
                  <div className="typography-div">
                    <Typography sx={cardHeading}>Air Conditioner</Typography>
                    <Typography variant="caption"
                      style={{ paddingRight: "40px" }}
                      sx={cardSubHeading}
                    >
                      Living Room
                    </Typography>
                  </div>
                </div>
                <Switch defaultChecked />
              </Grid>
              <Grid xs={12} md={12} sx={{ height: 100, padding: 0 }}>
                <Typography variant="h3" sx={tempStyle}>
                  22°C
                </Typography>
                <Typography variant="caption" sx={cardSubHeading}>
                  Room Temperature
                </Typography>
              </Grid>
              <Grid
                xs={12}
                md={12}
                sx={{
                  height: 90,
                  padding: 0,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {/* <Avatar sx={{ width: "373px", height: 57 }} src={TeroIcom} /> */}
                <TemperatureSlider />
              </Grid>
              <Grid sx={{ marginTop: '-18px' }} xs={5} sm={6} md={6}>
                <ButtonItem sx={{ height: 40 }}>Flap</ButtonItem>
              </Grid>
              <Grid sx={{ marginTop: '-18px' }} xs={5} sm={6} md={6}>
                <ButtonItem sx={{ height: 40 }}>Sleep</ButtonItem>
              </Grid>
            </Grid>
          </Item>
        </Grid>

        <Grid xs={12} md={6}>
          <Item>
            <Grid container>
              <Grid md={12} sx={cardHeaderStyle}>
                <Avatar
                  sx={{ width: 49, height: 49 }}
                  alt="conference iocn"
                  src={ConferenceIcon}
                />
                <div className="typography-div">
                  <Typography variant="h3" sx={cardHeading}>
                    Conference Room
                  </Typography>
                  <Typography variant="caption" sx={cardSubHeading}>
                    Video Equipment
                  </Typography>
                </div>
              </Grid>
              <Grid container xs={12} md={12}>
                <Grid xs={12} sm={6} md={6}>
                  <div className="display-video">
                    <Avatar
                      sx={{ width: 49, height: 49 }}
                      src={!videoDisplay ? DisplayAction : DisplayactionYellow}
                    />
                    <Switch
                      checked={videoDisplay}
                      onChange={handleSwitchChange}
                      name="display"
                    />
                  </div>
                  <div className="display-text">
                    <Typography variant="h3" sx={cardHeading}>
                      Phillips Display
                    </Typography>
                    <Typography variant="caption" sx={cardSubHeading}>
                      Inactive for 8 hours
                    </Typography>
                  </div>
                </Grid>
                <Grid xs={12} sm={6} md={6}>
                  <div className="display-video">
                    <Avatar
                      sx={{ width: 49, height: 49 }}
                      src={projectorDisplay ? ProjectorYellow : Projector}
                    />
                    <Switch
                      checked={projectorDisplay}
                      onChange={handleSwitchChange}
                      name="projector"
                    />
                  </div>
                  <div className="display-text">
                    <Typography variant="h3" sx={cardHeading}>
                      Epson Projector
                    </Typography>
                    <Typography variant="caption" sx={cardSubHeading}>
                      Inactive for 4 hours
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Item>
        </Grid>

        <Grid xs={12} md={6}>
          <Item>
            <Grid container>
              <Grid md={12} sx={cardHeaderStyle}>
                <Avatar
                  sx={{ width: 49, height: 49 }}
                  alt="conference icon"
                  src={OcoIcon}
                />
                <div className="typography-div">
                  <Typography variant="h3" sx={cardHeading}>
                    Room Occupancy
                  </Typography>
                  <Typography variant="caption" sx={cardSubHeading}>
                    CEO’s Office
                  </Typography>
                </div>
              </Grid>
              <Grid sx={{ padding: 0 }}>
                {/* <Avatar sx={{ width: 289, height: 205 }} src={Graph} /> */}
                <LineChart />
              </Grid>
            </Grid>
          </Item>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardComponent;
